import { SaleNoteReport } from '../../../../../core';

export const saleNoteReport = {
    searchText: '',
    sort: true,
    dialogHability: true,
    filter: false,
    paginator: true,
    checkbox: false,
    export: true,
    exportAllData: true,
    exportFile: "reporte_nota_venta.xlsx",
    expandable: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Número de N/V',
        name: 'saleNoteId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.saleNoteId
      },
      {
        title: 'Número de Cotizaci\u00F3n',
        name: 'quotationNumber',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.quotationNumber ? element.quotationNumber : ''
      },
      {
        title: 'Canal de venta',
        name: 'channel',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.channel
      },
      {
        title: 'Sucursal de venta',
        name: 'saleLocationName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.saleLocationName
      },
      {
        title: 'C\u00F3digo vtex',
        name: 'ecommerceId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.ecommerceId ? element.ecommerceId : ''
      },
      {
        title: 'Estado de pago',
        name: 'paymentState',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.paymentState ? element.paymentState : ''
      },
      {
        title: 'Estado de N/V',
        name: 'stateName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.stateName
      },
      {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.skuCode
      },
      {
        title: 'Descripci\u00F3n',
        name: 'skuName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.skuName
      },
      {
        title: 'Divisi\u00F3n',
        name: 'divisionDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.divisionDescription ? element.divisionDescription : ''
      },
      {
        title: 'Área',
        name: 'areaDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.areaDescription ? element.areaDescription : ''
      },
      {
        title: 'Departamento',
        name: 'departmentDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.departmentDescription ? element.departmentDescription : ''
      },
      {
        title: 'Línea',
        name: 'lineDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.lineDescription ? element.lineDescription : ''
      },
      {
        title: 'Cantidad comprada',
        name: 'purchasedAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.purchasedAmount
      },
      {
        title: 'Cantidad entregada',
        name: 'deliveredAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.deliveredAmount ? element.deliveredAmount : ''
      },
      {
        title: 'Cantidad cancelada',
        name: 'cancelledAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.cancelledAmount ? element.cancelledAmount : ''
      },
      {
        title: 'Precio final SKU',
        name: 'price',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => parseFloat(element.price).toFixed(2)
      },
      {
        title: 'Precio total de NV',
        name: 'totalPrice',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => parseFloat(element.totalPrice).toFixed(2)
      },
      {
        title: 'Estado del despacho',
        name: 'itemState',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.itemState
      },
      {
        title: 'Tipo Doc.',
        name: 'customerDocumentType',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.customerDocumentType ? element.customerDocumentType : ''
      },
      {
        title: 'Nro. Doc',
        name: 'customerDocumentNumber',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.customerDocumentNumber ? element.customerDocumentNumber : ''
      },
      {
        title: 'Nombre de cliente',
        name: 'customerName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.firstName + ' ' + (element.lastName ? element.lastName : '-')
      },
      {
        title: 'Telf. cliente',
        name: 'contactPhone',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.contactPhone ? element.contactPhone : ''
      },
      {
        title: 'Correo cliente',
        name: 'contactEmail',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.contactEmail ? element.contactEmail : ''
      },
      {
        title: 'Fecha y hora de venta',
        name: 'saleDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center dateInfo',
        value: (element: SaleNoteReport) => element.saleDate ? element.saleDate : ''
      },
      {
        title: 'Fecha y hora de pago',
        name: 'paymentDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center dateInfo',
        value: (element: SaleNoteReport) => element.paymentDate ? element.paymentDate : ''
      },
      {
        title: 'Fecha de entrega',
        name: 'deliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.deliveryDate ? element.deliveryDate : ''
      },
      {
        title: 'Inicio de ventana horaria',
        name: 'startDateDeliveryWindow',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.startDateDeliveryWindow ? element.startDateDeliveryWindow : ''
      },
      {
        title: 'Fin de ventana horaria',
        name: 'endDateDeliveryWindow',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.endDateDeliveryWindow ? element.endDateDeliveryWindow : ''
      },
      {
        title: 'Tipo de despacho',
        name: 'deliveryAgreement',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.deliveryAgreement ? element.deliveryAgreement : ''
      },
      {
        title: 'Modalidad de entrega',
        name: 'dispatchTypeName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.dispatchTypeName ? element.dispatchTypeName : ''
      },
      {
        title: 'Ruta',
        name: 'route',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.route ? element.route : ''
      },
      {
        title: 'Origen de stock',
        name: 'originEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.originEntity ? element.originEntity : ''
      },
      {
        title: 'Entidad final de ruta',
        name: 'deliveryEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.deliveryEntity ? element.deliveryEntity : ''
      },
      {
        title: 'Vendedor',
        name: 'saleUser',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.saleUser ? element.saleUser : ''
      },
      {
        title: 'Motivo de cancelación',
        name: 'reasonCancellation',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.reasonCancellation ? element.reasonCancellation : ''
      },
      {
        title: 'Usuario de anulación',
        name: 'userCancellation',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.userCancellation ? element.userCancellation : ''
      },
      {
        title: 'Generó ASN hacia CD',
        name: 'generatedASN',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.generatedASN ? element.generatedASN : ''
      },
      {
        title: 'Inv. a CD',
        name: 'adjustWMS',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.adjustWMS ? element.adjustWMS : ''
      },
      {
        title: 'Tipo de Mercadería',
        name: 'division',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.division ? element.division : ''
      },
      {
        title: 'Agrupación de entidad inicial',
        name: 'originGroupName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.originGroupName
      },
      {
        title: 'Agrupación de entidad final',
        name: 'finalGroupName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteReport) => element.finalGroupName
      }
    ]
  };
